Ext.define('SA.view.sidebar.data.DataFacetCheckBoxGroup', {
    alias: 'widget.data-search-checkbox-group',
    extend: 'Ext.Component',

    baseCls: 'sa-sidebar-data-checkbox-group',

    tpl: [
        '<div class="sa-sidebar-data-checkbox-group-title">{title:htmlEncode}</div>',
        '<div class="sa-sidebar-data-checkbox-group-body">',
            '<tpl for="values">',
                '<button data-value="{value:htmlEncode}" class="sa-sidebar-data-checkbox<tpl if="selected"> sa-sidebar-data-checkbox-selected</tpl>">',
                    '<span class="sa-sidebar-data-checkbox-button"></span>',
                    '<span class="sa-sidebar-data-checkbox-label">{text:htmlEncode}</span>',
                    ' ',
                    '<span class="sa-sidebar-data-checkbox-count">({count})</span>',
                '</button>',
            '</tpl>',
        '</div>'
    ],

    initComponent() {
        this.selected = this.selected || [];
        this.values = this.values || {};

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-sidebar-data-checkbox',
            scope: this,

            click: this.onItemClick,
            mouseout: this.onMouseOut,
            mouseover: this.onMouseOver
        });
    },

    addToSelection(values) {
        var selected = this.selected;

        values = Array.isArray(values) ? values : [values];

        values.forEach(value => {
            if (!selected.includes(value)) {
                selected.push(value);
            }
        });

        this.setSelected(selected);
    },

    isSelected(value) {
        return this.selected.includes(value);
    },

    mergeValues(values) {
        var merged = this.values;

        for (let value in values) {
            merged[value] = values[value];
        }

        this.setValues(merged);
    },

    onItemClick(ev, el) {
        var value = el.getAttribute('data-value');

        if (value) {
            this.toggleSelection(value);
        }
    },

    onMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-sidebar-data-checkbox-over');
    },

    onMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-sidebar-data-checkbox-over');
    },

    prepareValues(valueCounts, selected) {
        var values = [];

        selected = selected.slice();

        for (let name in valueCounts) {
            let count = valueCounts[name],
                value = {value: name, count};

            if (selected.includes(value.value)) {
                Ext.Array.remove(selected, value.value);

                value.selected = true;
            }

            values.push(value);
        }

        selected.forEach(value => {
            values.push({
                count: 0,
                selected: true,
                value
            });
        });

        return values;
    },

    refresh() {
        var title = this.title,
            values = this.prepareValues(this.values, this.selected);

        values.forEach(value => {
            value.text = this.valueToText(value.value);
        });

        values.sort(this.sortFn);

        this.setVisible(values.length);

        this.update({title, values});
    },

    removeFromSelection(values) {
        values = Array.isArray(values) ? values : [values];

        this.setSelected(this.selected.filter(value => !values.includes(value)));
    },

    setSelected(selected) {
        this.selected = selected;

        this.refresh();

        this.fireEvent('select', this, selected);
    },

    setValues(values) {
        var newValues = {};

        for (let name in values) {
            let count = values[name];

            if (count) {
                newValues[name] = count;
            }
        }

        this.values = newValues;

        this.refresh();
    },

    sortFn(a, b) {
        return a.text < b.text ? -1 : 1;
    },

    toggleSelection(value) {
        if (this.isSelected(value)) {
            this.removeFromSelection(value);
        }
        else {
            this.addToSelection(value);
        }
    },

    valueToText(value) {
        if (value === 'true') {
            return this.title;
        }

        return value;
    }
});
